import { Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PreLoginRoutes } from "./routes/preLoginRoutes";
import { PostLoginRoutes } from "./routes/postLoginRoutes";
import ProtectedRoutes from "./utils/validations/protectedRoutes";
import Loader from "./components/Loader";
import useApi from "./hooks/useApi";
import loginService from "./api/services/loginService";
import { clearUser, setUser } from "./redux/slices/userSlice";

function AppRoutes() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [authChecked, setAuthChecked] = useState(false);

  const { callApi: userLoginData } = useApi(
    loginService.userLoginData,
    null,
    false,
  );

  useEffect(() => {
    const isPreLoginRoute = PreLoginRoutes.some(
      (route) => route.path === location.pathname,
    );

    if (isPreLoginRoute) {
      setAuthChecked(true);
      return;
    }

    let mounted = true;

    userLoginData({}, (response, err) => {
      if (!mounted) return;

      if (response?.code === 200) {
        dispatch(setUser(response.data.result));
      } else {
        dispatch(clearUser());
      }

      setAuthChecked(true);
    });

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [location.pathname]);

  if (!authChecked) return <Loader />;

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />

        {PreLoginRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {PostLoginRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            element={
              <ProtectedRoutes>
                <route.element />
              </ProtectedRoutes>
            }
          />
        ))}
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
